module.exports = __webpack_public_path__ + "img/20141229151653_HiM8B.a9bca976.jpeg";